import{css as o}from"styled-components";import{CommonFontStyle as m}from"./common.js";const t=o`
  font-family: helvetica, sans-serif;
  ${m};
`;export{t as HelveticaFontStyle};
//# sourceMappingURL=helveticaFontStyle.js.map
